import * as React from "react";
const EyeIconSvg = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={40} height={40} rx={20} fill="#e5e5e5" />
    <path
      d="M10 20s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EyeIconSvg;
